import { render, staticRenderFns } from "./title-item.vue?vue&type=template&id=02676244&scoped=true&"
import script from "./title-item.vue?vue&type=script&lang=js&"
export * from "./title-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02676244",
  null
  
)

export default component.exports